/**
 * Type-safe event register.
 *
 * EventMap defines the mapping of events to their context object types.
 */
export class EventRegister {
    constructor() {
        Object.defineProperty(this, "callbacks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.callbacks = new Map();
    }
    /**
     * Register an event callback.
     *
     * @param type
     * @param callback
     */
    register(type, callback) {
        let set = this.callbacks.get(type);
        if (!set) {
            set = [];
            this.callbacks.set(type, set);
        }
        set.push(callback);
    }
    /**
     * Unregister an event callback, returning whether or not it existed in the set.
     *
     * @param type
     * @param callback
     * @returns
     */
    unregister(type, callback) {
        let set = this.callbacks.get(type);
        if (!set) {
            set = [];
            this.callbacks.set(type, set);
        }
        const index = set.indexOf(callback);
        if (index >= 0) {
            set.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
     * Unregister all event callbacks.
     */
    unregisterAll() {
        for (const [_, array] of this.callbacks) {
            array.length = 0;
        }
    }
    /**
     * Get all the callbacks registered to an event.
     *
     * @param type
     * @returns
     */
    getCallbacks(type) {
        const callbacks = this.callbacks.get(type);
        if (callbacks) {
            return [...callbacks];
        }
        else {
            return [];
        }
    }
}
